import {UI} from "../../../stemjs/src/ui/UIBase.js";
import {CardPanel} from "../../../stemjs/src/ui/CardPanel.jsx";
import {ALGORITHMS_ARCHIVE_ID, INTERVIEWS_ARCHIVE_ID} from "../state/CSASettings.js";
import {ContestStore} from "../../../contest/js/state/ContestStore.js";
import {Router} from "../../../stemjs/src/ui/Router.jsx";
import {LoginModal} from "../../../establishment/accounts/js/LoginModal.jsx";
import {Ajax} from "../../../stemjs/src/base/Ajax.js";
import {ContestUserStore} from "../../../contest/js/state/ContestUserStore.js";
import {PopupSpan} from "../../../establishment/content/js/PopupSpan.jsx";
import {UserHandle} from "../../../csaaccounts/js/UserHandle.jsx";
import {ContestTimeCounter} from "../../../contest/js/ContestTimeCounter.jsx";
import {Button} from "../../../stemjs/src/ui/button/Button.jsx";
import {Level, Size} from "../../../stemjs/src/ui/Constants.js";

class HourlyContestWidget extends UI.Element {
    getContests() {
        let hourlyContests = ContestStore.all().filter(contest => (contest.systemGenerated && !contest.hasFinished() &&
            contest.originArchiveId === this.options.originArchiveId))
            .sort((a, b) => {
                return a.getStartTime() - b.getStartTime();
            });
        if (hourlyContests.length === 0) {
            return null;
        }
        return hourlyContests;
    }

    goToContest(contest) {
        if (contest.isRunning() || contest.getUser(USER.id)) {
            Router.changeURL(["contest", contest.name]);
            return;
        }
        if (!USER.isAuthenticated) {
            LoginModal.show();
            return;
        }

        let request = {
            contestId: contest.id,
        };

        Ajax.postJSON("/contest/register/", request).then(
            () => this.redraw()
        );
    }

    render() {
        let nextContests = this.getContests();
        let children = [<div style={{"width": "100%", "font-size": ".9em", textTransform: "uppercase", height: "28px", fontWeight: "bold"}}>
            {this.options.name}
        </div>];
        let containerStyle = {
            flex: "1",
            padding: "4px",
            minHeight: "120px",
            verticalAlign: "middle",
            position: "relative",
        };

        let emStyle = {
            position: "absolute",
            width: "100%",
            left: "50%",
            top: "50%",
            transform: "translate(-50%, -50%)",
        };

        if (!nextContests) {
            children.push(<div style={containerStyle}><em style={emStyle}>{UI.T("No contest scheduled")}</em></div>);
        } else {
            if (nextContests.length === 1 && !nextContests[0].isRunning()) {
                children.push(<div style={containerStyle}><em style={emStyle}>{UI.T("No contest running")}</em></div>);
            }
            for (let nextContest of nextContests) {
                let label = UI.T("Register"), title = UI.T("Next contest");
                let usersRegistered, usersRegisteredSpan;
                if (nextContest.isRunning()) {
                    title = UI.T("Current contest");
                } else {
                    usersRegistered = ContestUserStore.all().filter((contestUser) => (contestUser.contestId === nextContest.id));
                    if (usersRegistered.length > 0) {
                        usersRegisteredSpan = <div style={{"display": "block", "position": "relative"}}>
                            <PopupSpan style={{position: "relative", overflow: "hidden", "cursor": "pointer", "color": "blue"}}
                                       popupContent={
                                           () => usersRegistered.map(
                                               user => <div style={{"width": "100%", "height": "25px", "line-height": "25px"}}>
                                                   <UserHandle userId={user.userId}/>
                                               </div>
                                           )
                                       }>
                                {UI.T("Users registered")}: {usersRegistered.length}
                            </PopupSpan>
                        </div>
                    }
                }
                if (nextContest.isRunning() || nextContest.getUser(USER.id)) {
                    label = UI.T("Go to contest");
                }

                children.push(<div style={containerStyle}>
                    <h5 style={{textTransform: "uppercase", fontWeight: "bold", fontSize: "90%"}}>
                        {title}
                    </h5>
                    <div>
                        <ContestTimeCounter contest={nextContest}/>
                    </div>
                    <div>
                        <Button onClick={() => {
                            this.goToContest(nextContest);
                        }} level={Level.PRIMARY} size={Size.SMALL}>
                            {label}
                        </Button>
                    </div>
                    {usersRegisteredSpan}
                </div>);
            }
        }
        return <div style={{width: "100%", display: "flex", flexDirection: "column", textAlign: "center"}}>
            {children}
        </div>;
    }

    onMount() {
        super.onMount();
        ContestStore.addCreateListener(() => {
            this.redraw();
        });
        ContestUserStore.addCreateListener((contestUser) => {
            let contest = contestUser.getContest();
            if (contest && contest.systemGenerated && !contest.hasFinished() && contest.originArchiveId === this.options.originArchiveId) {
                this.redraw();
            }
        });
        ContestStore.addDeleteListener(() => {
            this.redraw();
        });
    }
}

export class HourlyContestsPanel extends UI.Element {
    render() {
        let panelStyle = {
            flex: "1",
            paddingTop: "8px",
            paddingBottom: "8px",
        };

        return [
            <CardPanel title={UI.T("Hourly Contests")} style={{display: "flex", flexDirection: "column"}} bodyStyle={{display: "flex", flex: "1"}}>
                <HourlyContestWidget originArchiveId={ALGORITHMS_ARCHIVE_ID} name={UI.T("Algorithms")} style={panelStyle}/>
                <HourlyContestWidget originArchiveId={INTERVIEWS_ARCHIVE_ID} name={UI.T("Interviews")} style={panelStyle}/>
            </CardPanel>
        ];
    }
}